import { useQuery } from '@tanstack/react-query';
import {
  IAutoAddProductsParams,
  IComboProductsParams,
  IMenuProductsParams,
  IModifierProductsParams,
  IProductParams,
  ISingleProductParams,
} from '../model/product.dto';
import productApi from './client';

export const useCartProducts = (params: IProductParams, enabled?: boolean) =>
  useQuery({
    queryKey: ['products', 'cart', params],
    queryFn: () => productApi.getAll(params),
    enabled,
  });

export const useSingleProduct = (id: string, params: ISingleProductParams) =>
  useQuery({
    queryKey: ['products', 'single', id],
    queryFn: () => productApi.getSingle(id, params),
    enabled: !!id && !!params.partner_shipper_id,
  });

export const useComboProducts = (
  id: string,
  params: IComboProductsParams,
  { enabled }: { enabled: boolean }
) =>
  useQuery({
    queryKey: ['products', 'combos', params],
    queryFn: () => productApi.getComboById(id, params),
    enabled,
  });

export const useMenuProducts = (
  params: IMenuProductsParams,
  { enabled }: { enabled: boolean }
) =>
  useQuery({
    queryKey: ['products', 'menu', params],
    queryFn: () => productApi.getMenuProducts(params),
    enabled,
  });

export const useAutoAddProducts = (
  params: IAutoAddProductsParams,
  { enabled }: { enabled: boolean }
) =>
  useQuery({
    queryKey: ['products', 'auto-add', params],
    queryFn: () => productApi.getAutoAddProducts(params),
    enabled,
    select: (res) => res?.products?.filter((item) => !item.need_recommend),
  });

export const useProductModifiers = (params: IModifierProductsParams) =>
  useQuery({
    queryKey: ['product', 'modifiers', params],
    queryFn: () => productApi.getProductModifier(params),
    enabled: !!params.product_id && !!params.partner_shipper_id,
  });
